/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Login_Methods_Save_SuccessInputs */



/**
* | output |
* | --- |
* | "Sign-in methods updated." |
*
* @param {Member_Login_Methods_Save_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_login_methods_save_success = /** @type {((inputs?: Member_Login_Methods_Save_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Login_Methods_Save_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmeldemethoden aktualisiert.")
	return /** @type {LocalizedString} */ ("Sign-in methods updated.")
});